import { render, staticRenderFns } from "./SettingActivityDialog.vue?vue&type=template&id=5f866743&scoped=true"
import script from "./SettingActivityDialog.vue?vue&type=script&lang=js"
export * from "./SettingActivityDialog.vue?vue&type=script&lang=js"
import style0 from "./SettingActivityDialog.vue?vue&type=style&index=0&id=5f866743&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f866743",
  null
  
)

export default component.exports